import REAR_BIN_MAPPING from './rear-bin-mapping';

let init = () => {
  console.log('Board not connected');
};

let updatePaymentStatus;

// let wrapperObj = null;
let ipcRendererObj = null;
let openBin = binId => {
  console.log(`openBin called with ${binId}`);
  console.log('Board not connected');
};

let writeSettings = FileObj => {
  console.log(`writeSettings called with ${JSON.stringify(FileObj)}`);
};

let writeInitSettings = FileObj => {
  console.log(`writeInitSettings called with ${JSON.stringify(FileObj)}`);
};

let readSettings = () => {
  console.log(`readSettings called to get settings`);
};

let POSHandler = (event, args) => {
  console.log(`event ${event} and args ${args}`);
};

let closeApplication = () => {
  console.log('Not running in electronjs');
  localStorage.removeItem('permissionUser');
  localStorage.removeItem('permissions');

  let n = sessionStorage.length;
  while (n--) {
    let key = sessionStorage.key(n);
    if (key) {
      sessionStorage.removeItem(key);
    }
  }
};

let authRequest = (
  transactionId,
  totalAmount,
  transactions,
  updatePaymentStatusFunction
) => {
  console.log(
    `writeToPOS called with command :  ${(transactionId,
    totalAmount,
    transactions)}`
  );
  console.log('Board not connected');
};

if (window.electron) {
  let { /* app, */ ipcRenderer, remote } = window.electron;
  // if (app) wrapperObj = app;
  if (ipcRenderer) ipcRendererObj = ipcRenderer;

  closeApplication = () => {
    remote.getCurrentWindow().close();
    localStorage.removeItem('permissionUser');
    localStorage.removeItem('permissions');

    let n = sessionStorage.length;
    while (n--) {
      let key = sessionStorage.key(n);
      if (key) {
        sessionStorage.removeItem(key);
      }
    }
  };

  writeSettings = FileObj => {
    const command = JSON.stringify({
      command: 'write',
      FileObj
    });

    if (ipcRendererObj) {
      ipcRendererObj.send('kiosk-to-main', command);
    }
  };

  writeInitSettings = FileObj => {
    const command = JSON.stringify({
      command: 'write-init',
      FileObj
    });

    if (ipcRendererObj) {
      ipcRendererObj.send('kiosk-to-main', command);
    }
  };

  readSettings = () => {
    if (ipcRendererObj) {
      const fileData = ipcRenderer.sendSync('readSettings', 'read');
      return fileData;
    }
  };

  openBin = binId => {
    //Added By Kishan for Rear Screen Bin Mapping
    let rearStock;
    if (window.electron) {
      const fileData = JSON.parse(readSettings());
      rearStock = fileData ? fileData.rearStock : '';
    } else {
      rearStock =
        localStorage.getItem('rearStock') &&
        (localStorage.getItem('rearStock') === 'true' ||
          localStorage.getItem('rearStock') === -true)
          ? true
          : false;
    }
    if (rearStock) {
      console.log('Before:', binId);
      binId = REAR_BIN_MAPPING[binId];
      console.log('openBin-RearStock:', binId);
    } else {
      console.log('openBin-Front:', binId);
    }
    const command = JSON.stringify({
      command: 'open-bin',
      binId
    });
    if (ipcRendererObj) {
      ipcRendererObj.send('kiosk-to-main', command);
    }
    console.log(command);
  };

  authRequest = (
    transactionId,
    amount,
    transactions,
    updatePaymentStatusFunction
  ) => {
    const command = JSON.stringify({
      command: 'auth-request',
      transactionId,
      amount,
      transactions
    });
    updatePaymentStatus = updatePaymentStatusFunction;
    if (ipcRendererObj) {
      ipcRendererObj.send('kiosk-to-main', command);
    }
    console.log(command);
  };

  POSHandler = (event, args) => {
    console.log(args);
    // eslint-disable-next-line default-case
    switch (args.event) {
      case 'swipe-expected':
        console.log(
          `SWIPE-EXPECTED is ${JSON.stringify(
            event
          )} and args are ${JSON.stringify(args)}`
        );
        updatePaymentStatus(
          'swipe-expected',
          'Please swipe your credit or debit card'
        );
        break;
      case 'authorizing':
        console.log(
          `AUTHORIZING is ${JSON.stringify(
            event
          )} and args are ${JSON.stringify(args)}`
        );
        updatePaymentStatus('authorizing', 'Authorizing...');
        break;
      case 'transaction':
        if (
          args.transctionApproved === true ||
          args.transctionApproved === 'true'
        ) {
          console.log(`TRANSACTION RESULT: Approved`);
          updatePaymentStatus('approved', 'Payment received.', args);
        } else {
          console.log(`TRANSACTION RESULT: Declined`);
          updatePaymentStatus('declined', 'Transaction failed.');
        }
        console.log(
          `event is ${JSON.stringify(event)} and args are ${JSON.stringify(
            args
          )}`
        );
        break;
    }
  };

  init = () => {
    if (ipcRendererObj) {
      ipcRendererObj.on('main-to-kiosk', (event, arg) => {
        // console.log('main-to-kiosk');
        // console.log(event);
        // console.log(arg);
        // console.log('message received by kiosk');
        POSHandler(event, arg);
      });
      console.log('Board initialized');
    } else {
      console.log('Board not initialized');
      console.log(ipcRendererObj);
    }
  };
}

export {
  init,
  /* wrapperObj, */ ipcRendererObj,
  openBin,
  writeSettings,
  readSettings,
  writeInitSettings,
  closeApplication,
  authRequest
};
